import React from 'react';
import DocumentIcon from 'components/atoms/icons/documentIcon';
import CopyableText from 'components/atoms/buttons/copyable-text';
import { useTranslation } from 'react-i18next';
import ClinicInvoiceTermSelectBox from 'components/molecules/clinic-invoice-terms-select-box';
import CustomerTypeSelectBox from 'components/molecules/customer-type-select-box';

import s from './styles.module.scss';

import type { IClinicInvoiceInfo } from 'infrastructure/interfaces';

interface IProps {
  data: IClinicInvoiceInfo;
}

const safeString = (str?: string | null) =>
  str && !!str.trim().length ? str : '-';

const ClinicInvoicesInfoViewForm: React.FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className={s['view-form']}>
      <ul className={s.list}>
        <li>
          {t('labels.invoiceTerms')}
          <span>
            <ClinicInvoiceTermSelectBox
              value={data.invoiceTerms}
              plaintext
              readonly
              placeholder=""
            />
          </span>
        </li>
        <li>
          {t('labels.customerType')}
          <span>
            <CustomerTypeSelectBox
              value={data.customerTypeGuid}
              plaintext
              readonly
              placeholder="-"
            />
          </span>
        </li>
        <li>
          {t('labels.folderName')} <span>{safeString(data.invoiceFolder)}</span>
        </li>
      </ul>

      <div className={s.invoice}>
        <div className={s.info}>
          <i>
            <DocumentIcon />
          </i>
          <p>
            {t('labels.invoiceNpi')}
            <br />
            <span>{t('labels.nationalProviderIdentifier')}</span>
          </p>
        </div>

        <div className={s.code}>
          <CopyableText
            value={safeString(data.invoiceNPI)}
            iconLocation="right"
          />
        </div>
      </div>
    </div>
  );
};

export default ClinicInvoicesInfoViewForm;
